import type { ExportAttemptsResponse } from '../types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { zodExportAttemptsResponseSchema } from '../validations';

/**
 * Retries a failed invoice export attempt.
 *
 * @param invoiceId - Invoice identifier.
 * @param attemptId - Export attempt identifier.
 * @returns Export attempts and their derived summary.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/retry_export_attempt_invoices__invoice_id__export_attempts__attempt_id__retry_post
 */
export async function retryInvoiceExportAttempt(
  invoiceId: UUID,
  attemptId: UUID,
) {
  return vestigasApi
    .post(ENDPOINT.INVOICE.RETRY_EXPORT_ATTEMPT(invoiceId, attemptId), {
      validate: {
        isResponseSensitive: true,
        response: zodExportAttemptsResponseSchema,
      },
    })
    .json<ExportAttemptsResponse>();
}
